/* Rquiere de mixin.js */

var payment = {
	data() {
		return {
			dateFromPayments: '2020-07-15',
			dateToPayments: '2020-07-18',
			dataPayment: {
				exists: 0,
				id: 0,
				type_payment_id: null,
				type_payment: {},
				amount: 0,
				bank_id: null,
				bank: {},
				code: '',
				description: '',
				transaction_date: '',
				status_id: 38,
				status: {},
				created_at: null,
				created_at: null,
			},
			listPayments: [],
			methodsPayment: {
				get: 'payments',
				show: 'payment',
				delete: 'delete'
			},
			paginationPayments: [],
			searchPayments: '',
			qRowsPayment: 25,
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		analizePaymentsRejectedLocal(payments) {
			let result = 0
			Object.values(payments).forEach(item => {
				if (item.status_id == 40) {
					result++
				}
			})
			return result
		},
		addListPayments(newPayment) {
			this.listPayments.push(newPayment)
		},
		changeQRowsPayment() {
			localStorage.setItem('qRowsPayment', this.qRowsPayment)
			this.changeQRowsPaymentLocal()
		},
		changeQRowsPaymentLocal() {
			console.log('changeQRowsPaymentLocal no desarrollado')
		},
		clearDataPayment() {
			this.dataPayment.exists = 0
			this.dataPayment.id = 0
			this.dataPayment.type_payment_id = null
			this.dataPayment.type_payment = {}
			this.dataPayment.amount = 0
			this.dataPayment.bank_id = null
			this.dataPayment.bank = null
			this.dataPayment.code = ''
			this.dataPayment.description = ''
			this.dataPayment.transaction_date = ''
			this.dataPayment.status_id = 38
			this.dataPayment.status = {}
			this.dataPayment.created_at = null
			this.dataPayment.created_at = null
		},
		deleteItemPayment(id) {
			let index = this.listPayments.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			let payments = this.listPayments.splice(index, 1)
		},
		deletePayment(controller, controllerId, id) {
			let url = this.apiBackend + controller + '/' + controllerId + '/' + this.methodsPayment.show + '/' + id + '/' + this.methodsPayment.delete
			this.axiosActionIS(url, 'DELETE', 'deletePaymentResult')
		},
		deletePaymentResult(response) {
			if (response.data.success === true) {
				this.deleteItemPayment(response.data.data)
			} else {
				console.log(response)
			}
			this.deletePaymentResultLocal(response)
		},
		deletePaymentResultLocal(response) {
			console.log('deletePaymentResultLocal no desarrollado', response)
		},
		getAllPayments(page = 1) {
			this.listPayments = []
			this.paginationPayments = []
			this.$emit('showLockScreen', 'Obteniendo lista de Pagos . . .')
			let parameters = '?search=' + this.searchPayments + '&page=' + page + '&qRow=' + this.qRowsPayment + '&fromDate=' + this.dateFromPayments + '&toDate=' + this.dateToPayments
			this.axiosActionIS(this.apiBackend + this.methodsPayment.get + parameters, 'GET', 'getAllPaymentsResult')
		},
		getAllPaymentsResult(response) {
			this.listPayments = response.data.data
			this.paginationPayments = response.data.paginate
			this.getAllPaymentsResultLocal(response)
		},
		getAllPaymentsResultLocal(response) {
			console.log('getAllPaymentsResultLocal no desarrollado', response)
		},
		getPaymentByController(id, controller = '') {
			let url = this.apiBackend + controller + '/' + id + '/' + this.methodsPayment.get
			this.axiosActionIS(url, 'GET', 'getPaymentByControllerResult')
		},
		getPaymentByControllerResult(response) {
			if (response.data.success === true) {
				this.listPayments = response.data.data
			} else {
				console.warn('El formato de la respuesta no es valida')
			}
			this.getPaymentByControllerResultLocal(response)
		},
		getPaymentByControllerResultLocal(response) {
			console.log('getPaymentByControllerResultLocal no desarrollado', response)
		},
		savePayment(controller, id) {
			let url = this.apiBackend + controller + '/' + id + '/' + this.methodsPayment.show + '/register'
			this.axiosActionIS(url, 'POST', 'savePaymentResult', this.dataPayment)
		},
		savePaymentResult(response) {
			if (response.data.success) {
				this.addListPayments(response.data.data)
			} else {
				console.log('No se puedo subir el archivo')
				console.log(response)
			}
			this.savePaymentResultLocal(response)
		},
		savePaymentResultLocal(response) {
			console.log('savePaymentResultLocal no desarrollado')
		},
		setPaymentInit() {
			this.qRowsPayment = (localStorage.getItem('qRowsPayment') === null) ? this.qRowsPayment : localStorage.getItem('qRowsPayment')
			this.dateFromPayments = this.currentDate(-30)
			this.dateToPayments = this.currentDate()
			this.setPaymentInitLocal()
		},
		updatePayment(id, column, value) {
			this.$emit('showLockScreen', 'Actualizando el estado del pago . . .')
			let data = {
				column: column,
				value: value
			}
			let url = this.apiBackend + this.methodsPayment.show + '/' + id + '/update'
			this.axiosActionIS(url, 'PUT', 'updatePaymentResult', data)
		},
		updatePaymentResult(response) {
			if (response.data.success === true) {
				Object.entries(this.listPayments).forEach(([key, value]) => {
					if (value.id == response.data.data.id) {
						this.listPayments[key].status_id = response.data.data.status_id
						this.listPayments[key].status = response.data.data.status
						this.listPayments[key].color = response.data.data.color
					}
				});
			}
			this.updatePaymentResultLocal(response)
		},
		updatePaymentResultLocal(response) {
			console.log('updatePaymentResultLocal no desarrollado', response)
		}
	},
};

export default payment;